import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  makeStyles,
  Modal,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles(() => ({
  card: {
    minWidth: 400,
    height: 600,
    maxHeight: '80vh',
    overflowY: 'auto',
    position: 'relative',
    padding: 10,
  },
  xsCard: {
    width: '100vw',
    height: '100vh',
    overflow: 'auto',
    position: 'relative',
    padding: 10,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    position: 'absolute',
    right: 20,
    top: 20,
  },
}));

type Props = {
  title: string;
  children: React.ReactChildren | React.ReactChild;
  showModal: boolean;
  setShowModal: (a: boolean) => void;
};

export default function CardModal({
  children,
  showModal,
  setShowModal,
  title,
}: Props): JSX.Element {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();

  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      className={classes.modal}
    >
      <Card className={fullScreen ? classes.xsCard : classes.card}>
        <CardHeader title={title} />
        <IconButton
          className={classes.icon}
          onClick={() => setShowModal(false)}
        >
          <Clear />
        </IconButton>
        <CardContent>{children}</CardContent>
      </Card>
    </Modal>
  );
}
